import { ReactElement } from 'react';
import { OrderManagement } from '@mapado/seating';
import EventDatePagesHeader from '../components/EventDatePagesHeader';
import useQueryNumberParam from '../useQueryNumberParam';

export default function DemoOrderManagement(): ReactElement {
  const eventDateId = useQueryNumberParam('eventDateId', 133018);

  return (
    <>
      <EventDatePagesHeader
        title="Gestion des commandes"
        eventDateId={eventDateId}
      />

      <OrderManagement eventDateId={eventDateId} />
    </>
  );
}
